/**
 * Dashboard page
 */

import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { listInstallations } from '../services/installations';
import type { Installation } from '../../../shared/src/types';
import '../styles/Dashboard.css';

export default function Dashboard() {
  const { user } = useAuth();
  const [installations, setInstallations] = useState<Installation[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      // Load only active installations for dashboard
      const data = await listInstallations({ status: 'active' });
      setInstallations(data);
    } catch (err) {
      console.error('Error loading installations:', err);
    } finally {
      setLoading(false);
    }
  };

  const activeInstallations = installations;
  const totalInstallations = installations.length;

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Dashboard</h1>
        <p className="dashboard-subtitle">Estado general del sistema</p>
      </div>

      <div className="status-banner">
        <div className="status-banner-content">
          <span className="status-icon">ℹ️</span>
          <div className="status-text">
            <strong>Sistema operativo</strong>
            <span>Bienvenido, {user?.name || user?.email}</span>
          </div>
        </div>
      </div>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h2>Instalaciones</h2>
          <div className="card-stat">
            <span className="stat-value">
              {loading ? '...' : activeInstallations.length}
            </span>
            <span className="stat-label">Activas</span>
          </div>
          <div className="card-action">
            <a href="/installations" className="btn-secondary">
              Ver instalaciones
            </a>
          </div>
        </div>

        <div className="dashboard-card">
          <h2>Checklists</h2>
          <div className="card-stat">
            <span className="stat-value">0</span>
            <span className="stat-label">Pendientes</span>
          </div>
          <div className="card-action">
            <a href="/checklists" className="btn-secondary">
              Ver checklists
            </a>
          </div>
        </div>

        <div className="dashboard-card">
          <h2>Informes</h2>
          <div className="card-stat">
            <span className="stat-value">0</span>
            <span className="stat-label">Generados</span>
          </div>
          <div className="card-action">
            <a href="/reports" className="btn-secondary">
              Ver informes
            </a>
          </div>
        </div>
      </div>

      <div className="next-action-card">
        <h2>Siguiente acción requerida</h2>
        {totalInstallations === 0 ? (
          <>
            <p>Crear tu primera instalación para comenzar</p>
            <a href="/installations" className="btn-primary">
              Crear instalación
            </a>
          </>
        ) : (
          <>
            <p>Tienes {activeInstallations.length} instalación(es) activa(s)</p>
            <a href="/installations" className="btn-primary">
              Ver instalaciones
            </a>
          </>
        )}
      </div>
    </div>
  );
}
